import React from 'react';

export const useScrollElement = (scrollRef) => {

    const onScroll = () => {
        scrollRef.current.scrollIntoView();
    };

    return {onScroll};
};